import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { SelectedTasksBar } from "src/app/components/SelectedTasksBar/SelectedTasksBar";
import { setSelectedTasks } from "src/redux";
import { RootState } from "src/redux/reducers";
import { ReactComponent as RubberIcon } from "src/images/rubber.svg";
import WorkspaceTasksAskAIButton from "../WorkspaceTasksAskAIButton";
import { TaskType } from "src/types";
import { Column } from "src/redux/dictionary/types";
import useCheckWorkspacePermission from "src/hooks/useCheckWorkspacePermission";

interface WorkspaceSelectedTasksBarProps {
  taskType: TaskType | undefined;
  columns: Column[];
}

export default function WorkspaceSelectedTasksBar({
  taskType,
  columns,
}: WorkspaceSelectedTasksBarProps) {
  const { selectedTasks } = useSelector(
    (state: RootState) => state.taskReducer,
  );

  const dispatch = useDispatch();

  const hasAccessToStartConversationWithAi =
    useCheckWorkspacePermission("AI_META_VALUE");

  const clearSelected = () => {
    dispatch(setSelectedTasks([]));
  };

  return (
    <SelectedTasksBar selectedTasksLength={selectedTasks.length}>
      {hasAccessToStartConversationWithAi && (
        <WorkspaceTasksAskAIButton taskType={taskType} columns={columns} />
      )}
      <Button
        size="large"
        variant="white"
        onClick={clearSelected}
        disabled={!selectedTasks.length}
        data-action="clearSelected"
      >
        <RubberIcon />
        <IDHFormattedMessage id="ws_clear_selected" defaultMessage="Clear" />
      </Button>
    </SelectedTasksBar>
  );
}
